/**
 * <com-h1 title=""></com-h1>
 * <com-h1 class="small" title=""></com-h1>
 * <com-h1 class="light" title=""></com-h1>
 */

import Title from './title'

export default Title
